var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.rows),function(x){return _c('tr',_vm._l((_vm.cols),function(x){return _c('td',[_c('div',{staticClass:"linear-background"})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }